const PathService = function ($sce, AppConfig) {
    'ngInject';

    /*
     @param {String} fileName
     @returns {Object}
     */
    const directivePartial = function (fileName) {
        if (AppConfig.partial_url) {
            const partialUrl = AppConfig.partial_url;
            return $sce.trustAsResourceUrl(`${partialUrl}/${fileName}.html`);
        } else {
            return $sce.trustAsResourceUrl(`${fileName}.html`);
        }
    };

    return {
        directivePartial
    };
};

angular
    .module('BB')
    .service('PathSvc', PathService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/path_svc.service.js